import { type Product, PRODUCTS } from './products';

export interface ProductMeta {
  type: 'main' | 'addon' | 'service';
  addonLabel?: string;
  inheritDims?: boolean;
  applies_to?: string[] | string;
}

export const PRODUCT_META: Record<string, ProductMeta> = {
  // ── Mozzy Net (2026 list) ────────────────────────────────────────────────────
  'MZN-001': { type: 'main' },
  'MZN-002': { type: 'main' },
  'MZN-003': { type: 'main' },
  'MZN-004': { type: 'main' },
  'MZN-005': { type: 'main' },
  'MZN-006': { type: 'main' },
  'MZN-007': { type: 'main' },
  'MZN-008': { type: 'main' },
  'MZN-009': { type: 'main' },
  'MZN-010': { type: 'main' },
  'MZN-011': { type: 'main' },

  // ── Aluminium Window (2026 list) ─────────────────────────────────────────────
  'AWN-001': { type: 'main' },
  'AWN-002': { type: 'main' },
  'AWN-003': { type: 'main' },
  'AWN-004': { type: 'main' },
  'AWN-005': { type: 'main' },
  'AWN-006': {
    type: 'addon',
    addonLabel: 'Window Type',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-007': {
    type: 'addon',
    addonLabel: 'Window Type',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-008': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_window',
  },
  'AWN-009': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_window',
  },
  'AWN-010': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-011': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-012': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_window',
  },
  'AWN-013': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-014': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-015': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_window',
  },
  'AWN-016': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_window',
  },
  'AWN-017': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_window',
  },
  'AWN-018': {
    type: 'addon',
    addonLabel: 'Structural',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-019': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_window',
  },
  'AWN-020': {
    type: 'addon',
    addonLabel: 'Hardware',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },
  'AWN-021': {
    type: 'addon',
    addonLabel: 'Hardware',
    inheritDims: false,
    applies_to: 'any_aluminium_window',
  },

  // ── Toilet Window (2026 list) ────────────────────────────────────────────────
  'TWN-001': { type: 'main' },
  'TWN-002': { type: 'main' },
  'TWN-003': { type: 'main' },
  'TWN-004': {
    type: 'addon',
    addonLabel: 'Glass',
    inheritDims: false,
    applies_to: 'any_toilet_window',
  },
  'TWN-005': {
    type: 'addon',
    addonLabel: 'Finish',
    inheritDims: false,
    applies_to: 'any_toilet_window',
  },
  'TWN-006': {
    type: 'addon',
    addonLabel: 'Service',
    inheritDims: false,
    applies_to: 'any_toilet_window',
  },
  'TWN-007': {
    type: 'addon',
    addonLabel: 'Service',
    inheritDims: false,
    applies_to: 'any_toilet_window',
  },
  'TWN-008': {
    type: 'addon',
    addonLabel: 'Service',
    inheritDims: false,
    applies_to: 'any_toilet_window',
  },
  'TWN-009': {
    type: 'addon',
    addonLabel: 'Service',
    inheritDims: false,
    applies_to: 'any_toilet_window',
  },
  'TWN-010': { type: 'main' },
  'TWN-011': { type: 'main' },
  'TWN-012': { type: 'main' },
  'TWN-013': {
    type: 'addon',
    addonLabel: 'Glass',
    inheritDims: false,
    applies_to: 'any_toilet_window',
  },

  // ── Slimness Door ────────────────────────────────────────────────────────────
  'SSL-001': { type: 'main' },
  'SSL-002': { type: 'main' },
  'SSL-003': { type: 'main' },
  'SSL-004': { type: 'main' },
  'SSL-005': { type: 'main' },
  'SSL-006': { type: 'main' },
  'SSL-007': { type: 'main' },
  'SSL-008': { type: 'main' },
  'SSL-009': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-010': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-011': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-012': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-013': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-014': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-015': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_slimness_door',
  },
  'SSL-016': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-017': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_slimness_door',
  },
  'SSL-018': {
    type: 'addon',
    addonLabel: 'Hardware',
    inheritDims: false,
    applies_to: 'any_slimness_door',
  },
  'SSL-019': {
    type: 'addon',
    addonLabel: 'Hardware',
    inheritDims: false,
    applies_to: 'any_slimness_door',
  },
  'SSL-020': {
    type: 'addon',
    addonLabel: 'Hardware',
    inheritDims: false,
    applies_to: 'any_slimness_door',
  },

  // ── Window Grille (2026 list) ────────────────────────────────────────────────
  'WGL-001': { type: 'main' },
  'WGL-002': { type: 'main' },
  'WGL-003': { type: 'main' },
  'WGL-004': {
    type: 'addon',
    addonLabel: 'Finish',
    inheritDims: true,
    applies_to: 'any_window_grille',
  },
  'WGL-005': {
    type: 'addon',
    addonLabel: 'Structural',
    inheritDims: true,
    applies_to: 'any_window_grille',
  },
  'WGL-006': {
    type: 'addon',
    addonLabel: 'Structural',
    inheritDims: false,
    applies_to: 'any_window_grille',
  },

  // ── Aluminium Sliding Door (2026 list) ───────────────────────────────────────
  'ASD-001': { type: 'main' },
  'ASD-002': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-003': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-004': {
    type: 'addon',
    addonLabel: 'Window Type',
    inheritDims: false,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-005': {
    type: 'addon',
    addonLabel: 'Window Type',
    inheritDims: false,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-006': {
    type: 'addon',
    addonLabel: 'Hardware',
    inheritDims: false,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-007': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-008': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-009': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-010': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_sliding_door',
  },
  'ASD-011': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_sliding_door',
  },

  // ── Aluminium Swing Door (2026 list) ─────────────────────────────────────────
  'ASW-001': { type: 'main' },
  'ASW-002': { type: 'main' },
  'ASW-003': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_swing_door',
  },
  'ASW-004': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_swing_door',
  },
  'ASW-005': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: true,
    applies_to: 'any_aluminium_swing_door',
  },
  'ASW-006': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_swing_door',
  },
  'ASW-007': {
    type: 'addon',
    addonLabel: 'Glass & Finish',
    inheritDims: false,
    applies_to: 'any_aluminium_swing_door',
  },

  // ── Service ───────────────────────────────────────────────────────────────
  'SER-001': { type: 'service' },
  'SER-002': { type: 'service' },
  'SER-003': { type: 'service' },
  'SER-004': { type: 'service' },
  'SER-005': { type: 'service' },
  'SER-006': { type: 'service' },
  'SER-007': { type: 'service' },
  'SER-008': { type: 'main' },
};

export const ADDON_LABEL_COLORS: Record<string, string> = {
  'Glass Upgrade': '#7cb8ff',
  Hardware: '#b07cff',
  Structural: '#ffaa7c',
  Finish: '#7cffb0',
  'Mesh Upgrade': '#c9a84c',
  Infill: '#ff7c9e',
  Scheduling: '#9e9a8e',
};

export function getProductType(code: string): 'main' | 'addon' | 'service' {
  return PRODUCT_META[code]?.type || 'main';
}

export function getAddonsFor(prdCode: string | null): Record<string, Product[]> {
  if (!prdCode) return {};
  const prod = PRODUCTS.find((p) => p.prd_code === prdCode);
  if (!prod) return {};

  const grouped: Record<string, Product[]> = {};
  PRODUCTS.forEach((p) => {
    const meta = PRODUCT_META[p.prd_code];
    if (!meta || meta.type !== 'addon') return;
    const at = meta.applies_to;
    let matches = false;

    if (Array.isArray(at)) {
      matches = at.includes(prdCode);
    } else if (at === 'any_slimness_door') matches = prod.cat1 === 'Slimness Door';
    else if (at === 'any_aluminium_window') matches = prod.cat1 === 'Aluminium Window';
    else if (at === 'any_toilet_window') matches = prod.cat1 === 'Toilet Window';
    else if (at === 'any_window_grille') matches = prod.cat1 === 'Window Grille';
    else if (at === 'any_aluminium_sliding_door') matches = prod.cat1 === 'Aluminium Sliding Door';
    else if (at === 'any_aluminium_swing_door') matches = prod.cat1 === 'Aluminium Swing Door';
    else if (at === 'any_mozzy_window')
      matches = prod.cat1 === 'Mozzy Net Window' || prod.cat1 === 'Mozzy Net Pro Window';
    else if (at === 'any_mozzy_door')
      matches = prod.cat1 === 'Mozzy Net Door' || prod.cat1 === 'Mozzy Net Pro Door';

    if (!matches) return;

    const label = meta.addonLabel || 'Option';
    if (!grouped[label]) grouped[label] = [];
    grouped[label].push(p);
  });

  return grouped;
}
